const ForecastValidationMessages = {
  HEADER_VALIDATION_DEFAULT_MESSAGE: 'The header fields do not match.',
  HEADER_VALIDATION_FAILED: 'The header fields do not match.',
  HEADER_VALIDATION_N_PROGRESS: 'Validating file format & header',
  HEADER_VALIDATION_SUCCESS: 'The header fields are valid',
  HEADER_VALIDATION_ERROR: 'Header validation error',

  SKIPPED_DUE_TO_HEADER_FAILURE: 'Skipped due to header validation failure',

  NO_MODIFIED_ROWS: 'No modified rows to validate',

  VALIDATION_ERROR: 'Validation error',

  ERROR_READING_FILE: 'Error reading file',
  TRANSFORMATION_FAILED: 'File transformation failed',
  TRANSFORMATION_FAILED_DETAILS: 'Unable to to transform certain data. Upload aborted.',

  MANDATORY_FIELDS_VALIDATION_DEFAULT_MESSAGE: (mandatoryFields: string[]) => `The following fields are required: ${mandatoryFields.join(', ')}.`,
  MANDATORY_FIELDS_VALIDATION_IN_PROGRESS: 'Validating required fields',
  MANDATORY_FIELDS_VALIDATION_SUCCESS: 'All required fields are present',
  MANDATORY_FIELDS_VALIDATION_FAILED: 'Required fields are missing',
  MANDATORY_FIELDS_VALIDATION_ERROR: 'Required field validation error',

  NON_EDITABLE_FIELD_VALIDATION_DEFAULT: 'Modification Attempt on a Non-Editable Field',
  NON_EDITABLE_FIELD_VALIDATION_IN_PROGRESS: 'Validating non-editable fields',
  NON_EDITABLE_FIELD_VALIDATION_SUCCESS: 'Non-editable fields validation passed',
  NON_EDITABLE_FIELD_VALIDATION_FAILED: 'Non-editable fields validation failed',
  NON_EDITABLE_FIELD_VALIDATION_ERROR: 'Non-editable field validation error',

  SEGMENTS_VALIDATION_DEFAULT: 'Ensure that Corp Segments have valid data.',
  SEGMENTS_VALIDATION_IN_PROGRESS: 'Validating segments',
  SEGMENTS_VALIDATION_IN_SUCCESS: 'Valid segments',
  SEGMENTS_VALIDATION_IN_FAILED: 'Invalid segments',
  SEGMENTS_VALIDATION_IN_ERROR: 'Segment validation error',

  UNAUTHORIZED_ROWS_VALIDATION_DEFAULT: 'Update only the data you own.',
  UNAUTHORIZED_ROWS_VALIDATION_IN_PROGRESS: 'Validating unauthorized modifications',
  UNAUTHORIZED_ROWS_VALIDATION_SUCCESS: 'Authorization validated',
  UNAUTHORIZED_ROWS_VALIDATION_FAILED: 'Unauthorized modifications',
  UNAUTHORIZED_ROWS_VALIDATION_ERROR: 'Authorization validation error',

  DUPLICATE_RECORDS_VALIDATION_DEFAULT: `Duplicate records found in the data.`,
  DUPLICATE_RECORDS_VALIDATION_IN_PROGRESS: 'Checking for duplicate records',
  DUPLICATE_RECORDS_FOUND: 'Duplicate records found',
  NO_DUPLICATE_RECORDS: 'No duplicate records found',
  DUPLICATE_RECORDS_VALIDATION_ERROR: 'Error checking for duplicate records',

  EXISTING_RECORDS_VALIDATION_DEFAULT: `Checking if records already exist`,
  EXISTING_RECORDS_VALIDATION_IN_PROGRESS: 'Checking if records already exist',
  EXISTING_RECORDS_FOUND: 'Record already exists',
  NO_EXISTING_RECORDS: 'No existing records found',
  EXISTING_RECORDS_VALIDATION_ERROR: 'Error checking for existing records',

  FORECAST_MONTH_DATA_VALIDATION_DEFAULT: 'Forecast months should have valid values',
  FORECAST_MONTH_DATA_VALIDATION_IN_PROGRESS: 'Validating forecast month data',
  FORECAST_MONTH_DATA_VALIDATION_SUCCESS: 'Forecast month data is valid',
  FORECAST_MONTH_DATA_VALIDATION_FAILED: 'Forecast month data is invalid',
  FORECAST_MONTH_DATA_VALIDATION_ERROR: 'Error validating forecast month data',

  ACCOUNT_BUDGET_TYPE_MAPPING_VALIDATION_DEFAULT: 'Account and Budget Type should be valid combination',
  ACCOUNT_BUDGET_TYPE_MAPPING_VALIDATION_IN_PROGRESS: 'Validating Account and Budget Type combination',
  ACCOUNT_BUDGET_TYPE_MAPPING_VALIDATION_SUCCESS: 'Account and Budget Type combination is valid',
  ACCOUNT_BUDGET_TYPE_MAPPING_VALIDATION_FAILED: 'Account and Budget Type combination is invalid',
  ACCOUNT_BUDGET_TYPE_MAPPING_VALIDATION_ERROR: 'Error validating Account and Budget Type combination',

  BUDGET_OWNER_AND_COST_CENTER_VALIDATION_DEFAULT: 'Budget Owner and Cost Center should be valid combination',
  BUDGET_OWNER_AND_COST_CENTER_VALIDATION_IN_PROGRESS: 'Validating Budget Owner and Cost Center combination',
  BUDGET_OWNER_AND_COST_CENTER_VALIDATION_SUCCESS: 'Budget Owner and Cost Center combination is valid',
  BUDGET_OWNER_AND_COST_CENTER_VALIDATION_FAILED: 'Budget Owner and Cost Center combination is invalid',
  BUDGET_OWNER_AND_COST_CENTER_VALIDATION_ERROR: 'Error validating Budget Owner and Cost Center combination',

  CC_AUTHORIZATION_VALIDATION_DEFAULT: 'Unauthorized Cost Center(s) found in the file',
  CC_AUTHORIZATION_VALIDATION_IN_PROGRESS: 'Validating Cost Center(s) in file',
  CC_AUTHORIZATION_VALIDATION_SUCCESS: 'Authorized Cost Center(s)',
  CC_AUTHORIZATION_VALIDATION_FAILED: 'Unauthorized Cost Center(s) found',
  CC_AUTHORIZATION_VALIDATION_ERROR: 'Error validating Cost Center(s) authorization',

  BUDGET_OWNER_VALIDATION_DEFAULT: 'Unauthorized Budget Owner(s) found in the file',
  BUDGET_OWNER_VALIDATION_IN_PROGRESS: 'Validating Budget Owner(s) in file',
  BUDGET_OWNER_VALIDATION_SUCCESS: 'Authorized Budget Owner(s)',
  BUDGET_OWNER_VALIDATION_FAILED: 'Unauthorized Budget Owner(s) found',
  BUDGET_OWNER_VALIDATION_ERROR: 'Error validating Budget Owner(s) authorization',

  DMM_SEGMENTS_VALIDATION_FAILED: 'Invalid DMM business segment combinations found',
  DMM_SEGMENTS_VALIDATION_SUCCESS: 'All DMM business segment combinations are valid',
  DMM_SEGMENTS_VALIDATION_DEFAULT: 'Validating DMM business segment combinations',
  DMM_SEGMENTS_VALIDATION_IN_PROGRESS: 'Validating DMM business segment combinations...',

  //DMM works on BO + PL level
  DMM_BUDGET_OWNER_AND_COST_CENTER_VALIDATION_DEFAULT: 'Budget Owner and Product Line should be valid combination',
  DMM_BUDGET_OWNER_AND_COST_CENTER_VALIDATION_IN_PROGRESS: 'Validating Budget Owner and Product Line combination',
  DMM_BUDGET_OWNER_AND_COST_CENTER_VALIDATION_SUCCESS: 'Budget Owner and Product Line combination is valid',
  DMM_BUDGET_OWNER_AND_COST_CENTER_VALIDATION_FAILED: 'Budget Owner and Product Line combination is invalid',
  DMM_BUDGET_OWNER_AND_COST_CENTER_VALIDATION_ERROR: 'Error validating Budget Owner and Product Line combination',

  FILE_CHANGE_DETECTION_DEFAULT: 'Detecting changes between uploaded file and current data',
  FILE_CHANGE_DETECTION_SUCCESS: (modifiedCount: number, newCount: number) => {
    const parts: string[] = [];
    if (modifiedCount > 0) parts.push(`${modifiedCount} modified row${modifiedCount > 1 ? 's' : ''}`);
    if (newCount > 0) parts.push(`${newCount} new row${newCount > 1 ? 's' : ''}`);
    return `Changes detected: ${parts.join(' and ')}`;
  },
  FILE_CHANGE_DETECTION_FAILED: 'No changes detected — file is identical to current data'
};

export default ForecastValidationMessages;
